
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/illustrations",
      function () {
        return require("private-next-pages/illustrations/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/illustrations"])
      });
    }
  